<style lang="scss">
.productchannel .vview-select {
    width: auto !important;
}
</style>

<template>
    <div class="productchannel search-wrap searchb2c">
        <!-- 顶部按钮组 -->
        <aside class="search-btn">
            <ButtonGroup>
                <Button
                    size="large"
                    v-for="(item, index) in btnsearch"
                    :key="index"
                    :type="
                        changestatus === item.value && changekeys === item.type
                            ? 'primary'
                            : 'default'
                    "
                    @click="handleBtn(item.type, item.value)"
                >
                    {{ item.label }}
                </Button>
            </ButtonGroup>
        </aside>

        <!-- 主搜索区域 -->
        <article class="search-main clearfix">
            <!-- 右侧操作按钮 -->
            <div class="pull-right">
                <Form inline>
                    <Button
                        type="primary"
                        @click="update(true)"
                        icon="ios-search"
                    >
                        {{
                            $t("global.common.btn_search", {
                                defaultValue: "查询",
                            })
                        }}
                    </Button>
                    <Button @click="resetdata" icon="md-refresh">
                        {{
                            $t("global.common.reset", { defaultValue: "重置" })
                        }}
                    </Button>
                    <Button type="dashed" @click="isOpen = !isOpen">
                        {{
                            $t("global.common.btn_more", {
                                defaultValue: "更多查询",
                            })
                        }}
                        <Icon
                            type="ios-arrow-down"
                            class="margin-left-5"
                        ></Icon>
                    </Button>
                </Form>
            </div>

            <!-- 第一行搜索条件 -->
            <div class="pull-right">
                <Form :label-width="80" inline>
                    <FormItem
                        :label="
                            $t('global.common.organization', {
                                defaultValue: '组织',
                            })
                        "
                        style="width: 270px"
                    >
                        <Select
                            v-model="formData.IN_orgId"
                            filterable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-for="(item, index) in getOrgList"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.channel', {
                                defaultValue: '渠道',
                            })
                        "
                        style="width: 250px"
                    >
                        <Select
                            v-model="formData.IN_accountFlag"
                            filterable
                            clearable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-html="item.label"
                                v-for="item in accountsTarget"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="Asin" style="width: 230px">
                        <Input clearable v-model.trim="formData.EQ_asin" />
                    </FormItem>
                    <FormItem label="SellerSKU" style="width: 230px">
                        <Input clearable v-model.trim="formData.CN_sellerSku" />
                    </FormItem>
                    <FormItem label="ERPSKU" style="width: 230px">
                        <erpSkuInput
                            v-bind:value="formData.CN_erpSku"
                            :showread="'showyes'"
                            erpskutype="manage"
                            @on-data="handleErpSku"
                        ></erpSkuInput>
                    </FormItem>
                </Form>
            </div>
        </article>

        <!-- 更多查询条件 (折叠面板) -->
        <transition name="slide-both">
            <div v-show="isOpen">
                <Form class="search-other" :label-width="110" inline>
                    <FormItem
                        :label="
                            $t('erp.product.product_line', {
                                defaultValue: '项目',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.IN_lineId"
                            filterable
                            clearable
                            multiple
                            :max-tag-count="2"
                        >
                            <Option
                                v-html="item.label"
                                v-for="item in productTarget"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.isinactive', {
                                defaultValue: '是否停用',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.EQ_status"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in isUsed"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.channel.up_down_status', {
                                defaultValue: '上下架状态',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.EQ_saleState"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in saleStatuList"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="Item Label" style="width: 330px">
                        <vInput clearable v-model="formData.EQ_fnSku"></vInput>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.EQ_skuOrderType"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in orderTypeList"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.product.product_type', {
                                defaultValue: '产品类型',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select v-model="formData.EQ_type" filterable clearable>
                            <Option
                                v-for="item in productList"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.channel.is_push', {
                                defaultValue: '是否推送',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.EQ_isPush"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in isPushList"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.channel.is_active_plan', {
                                defaultValue: '是否启用透明计划',
                            })
                        "
                        style="width: 330px"
                    >
                        <Select
                            v-model="formData.EQ_amazonProductSerialStatus"
                            filterable
                            clearable
                        >
                            <Option
                                v-for="item in amazonProductSerialStatusList"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="Parent Asin" style="width: 330px">
                        <vInput clearable v-model="formData.CN_asin1"></vInput>
                    </FormItem>
                    <FormItem label="Listing Name" style="width: 330px">
                        <vInput
                            clearable
                            v-model="formData.CN_listingName"
                        ></vInput>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.channel.channel_product_name', {
                                defaultValue: '渠道产品名称',
                            })
                        "
                        style="width: 330px"
                    >
                        <vInput clearable v-model="formData.CN_title"></vInput>
                    </FormItem>
                    <FormItem label="List Price" style="width: 330px">
                        <Input
                            v-model="formData.GE_price"
                            style="width: 101px"
                        />
                        ~
                        <Input
                            v-model="formData.LE_price"
                            style="width: 101px"
                        />
                    </FormItem>
                    <FormItem label="Your Price" style="width: 330px">
                        <Input
                            v-model="formData.GE_yourPrice"
                            style="width: 101px"
                        />
                        ~
                        <Input
                            v-model="formData.LE_yourPrice"
                            style="width: 101px"
                        />
                    </FormItem>
                    <FormItem label="Sale Price" style="width: 330px">
                        <Input
                            v-model="formData.GE_salePrice"
                            style="width: 101px"
                        />
                        ~
                        <Input
                            v-model="formData.LE_salePrice"
                            style="width: 101px"
                        />
                    </FormItem>
                    <FormItem
                        :label="
                            $t('erp.channel.amz_upload_staff_time', {
                                defaultValue: 'AMZ上架时间',
                            })
                        "
                        style="width: 330px"
                    >
                        <DatePicker
                            type="daterange"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 220px"
                            ref="amazonTime"
                            :value="getdate1"
                            @on-change="handleChange"
                        ></DatePicker>
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.update_time', {
                                defaultValue: '更新时间',
                            })
                        "
                        style="width: 330px"
                    >
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            placeholder="Select date"
                            style="width: 220px"
                            ref="createdDate"
                            :value="getdate2"
                            @on-change="createTime"
                        ></DatePicker>
                    </FormItem>
                    <FormItem label="FBA库存配置" style="width: 330px">
                        <Select
                            v-model="formData.EQ_fbaInventoryType"
                            clearable
                        >
                            <Option
                                v-for="item in getFBAInventoryType"
                                :value="item.value"
                                :key="item.value"
                            >
                                {{ item.label }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="ASIN" style="width: 330px">
                        <Input
                            v-model="formData.IN_asin"
                            :rows="2"
                            placeholder="支持输入多个，一行一个ASIN"
                            type="textarea"
                        />
                    </FormItem>
                    <FormItem label="SellerSKU" style="width: 330px">
                        <Input
                            v-model="formData.IN_sellerSku"
                            :rows="2"
                            placeholder="支持输入多个，一行一个sellersku"
                            type="textarea"
                        />
                    </FormItem>
                </Form>
            </div>
        </transition>

        <!-- 批量操作按钮 -->
        <transition>
            <Form
                inline
                class="search-other"
                v-if="changekeys != 'LE_latestShipDate'"
            >
                <Button
                    class="margin-right-5 dark-primary"
                    @click="handleModal('add')"
                    >{{
                        $t("global.common.add", { defaultValue: "添加" })
                    }}</Button
                >
                <Button
                    v-if="SYSID !== 1000606"
                    type="waring"
                    class="margin-right-5"
                    @click="handleModal('syncAsin')"
                >
                    同步ASIN
                </Button>
                <Dropdown
                    @on-click="handleModal"
                    style="width: 120px"
                    v-if="productChannelSet"
                >
                    <Button type="error">
                        {{
                            $t("fbb.accountmanage.muti_active", {
                                defaultValue: "批量激活",
                            })
                        }}
                        /
                        {{
                            $t("global.common.inactive", {
                                defaultValue: "停用",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem name="actived">
                            {{
                                $t("erp.channel.active", {
                                    defaultValue: "激活",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem name="disabled">
                            {{
                                $t("global.common.inactive", {
                                    defaultValue: "停用",
                                })
                            }}
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </Form>
        </transition>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import erpSkuInput from "@components/templates/erpskuinput.vue";
import mixin from "../mixin";

export default {
    components: {
        erpSkuInput,
    },
    mixins: [mixin],
    data() {
        return {
            changestatus: "",
            SYSID: global.SYSID,
            aaaa: "",
            isOpen: false,
            getdate1: [],
            getdate2: [],
            routerName: this.$route.name,
            states: [],
            formData: {
                IN_lineId: "",
            },
            allisAddition: "",
            changekeys: "EQ_status", // 上下架状态
            saleStatuList: [
                {
                    value: "Hit Shelve",
                    label: this.$t("erp.channel.up_staff", {
                        defaultValue: "上架",
                    }),
                },
                {
                    value: "Not Sell",
                    label: this.$t("erp.channel.down_staff", {
                        defaultValue: "下架",
                    }),
                },
                {
                    value: "Off Shelve",
                    label: this.$t("erp.channel.temp_down_staff", {
                        defaultValue: "临时下架",
                    }),
                },
            ],
            // 是否停用
            isUsed: [
                {
                    value: "N",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "Y",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ],
            // 发货方式
            orderTypeList: [
                {
                    value: "0",
                    label: this.$t("erp.channel.auto", {
                        defaultValue: "自动",
                    }),
                },
                {
                    value: "1",
                    label: this.$t("erp.channel.manual", {
                        defaultValue: "手动",
                    }),
                },
            ],
            options: {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.recent_month", {
                            defaultValue: "最近一月",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.latest_quarter", {
                            defaultValue: "最近一季度",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            return [start, end];
                        },
                    },
                ],
            },
        };
    },
    created() {
        this.update();
        // this.timehandle()
        this.productChannelSet = this.handleAuth("erp.productChannel.adminSet");
    },
    mounted() {
        this.bus.$on("changelang", (val) => {
            setTimeout(() => {
                this.update(true);
            }, 600);
        });
    },
    computed: {
        ...mapState("boss", ["accounts"]),
        // accountList
        ...mapGetters("diction", [
            "getNewDifferentAllProductList",
            "getNewAccountList",
        ]),
        ...mapGetters("dictionary", ["getOrgList", "getCusAccountList"]),
        accountsTarget() {
            return this.getNewAccountList.map((item) => {
                const bool = item.attach.status === "inactive";
                return {
                    label: bool
                        ? `<span style='text-decoration:line-through'>${item.label}</span>`
                        : `${item.label}`,
                    value: item.value,
                    // disabled:bool
                };
            });
        },
        productTarget() {
            return this.getNewDifferentAllProductList.map((item) => {
                const bool = item.attach.flag === 3;
                return {
                    label: bool
                        ? `<span style='text-decoration:line-through'>${item.label}</span>`
                        : `${item.label}`,
                    value: item.value,
                };
            });
        },
        btnsearch() {
            return [
                {
                    value: "",
                    type: "EQ_status",
                    label: this.$t("global.common.all", {
                        defaultValue: "全部",
                    }),
                },
                {
                    value: "Y",
                    type: "EQ_status",
                    label: this.$tc("global.common.active", 1, {
                        defaultValue: "可用产品",
                    }),
                },
                {
                    value: "N",
                    type: "EQ_status",
                    label: this.$tc("global.common.inactive", 1, {
                        defaultValue: "停用产品",
                    }),
                },
            ];
        },
        productList() {
            return [
                {
                    value: "single",
                    type: "EQ_status",
                    label: this.$t("erp.channel.single_product", {
                        defaultValue: "简单产品",
                    }),
                },
                {
                    value: "bundle",
                    type: "EQ_status",
                    label: this.$t("erp.channel.bundle_product", {
                        defaultValue: "组合产品",
                    }),
                },
                {
                    value: "virtual",
                    type: "EQ_status",
                    label: this.$t("erp.channel.virtual_product", {
                        defaultValue: "虚拟产品",
                    }),
                },
            ];
        },
        isPushList() {
            return [
                {
                    value: "Y",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "N",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },
        amazonProductSerialStatusList() {
            return [
                {
                    value: "1",
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: "0",
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },
    },
    methods: {
        handleErpSku(row) {
            this.$set(this.formData, "CN_erpSku", row.erpSku);
        },
        handleModal(type, id) {
            this.$parent.handleOperates(id, type);
        },
        handleBtn(key, val, index) {
            this.changestatus = val;
            this.changekeys = key;
            this.getdate1 = [];
            this.getdate2 = [];
            this.$set(this.formData, key, val);
            this.update();
        },
        update(type, parms) {
            if (this.formData.IN_asin != null && this.formData.IN_asin != "") {
                if (!(this.formData.IN_asin instanceof Array)) {
                    let INorderNo = this.formData.IN_asin.replace(/\n/g, ",");
                    this.formData.IN_asin = INorderNo.split(",");
                }
            }
            if (
                this.formData.IN_sellerSku != null &&
                this.formData.IN_sellerSku != ""
            ) {
                if (!(this.formData.IN_sellerSku instanceof Array)) {
                    let INid = this.formData.IN_sellerSku.replace(/\n/g, ",");
                    this.formData.IN_sellerSku = INid.split(",");
                }
            }
            const formdata = { ...this.formData };
            this.$emit("on-update", { search: formdata, page: 1 });
        },
        resetdata() {
            this.getdate1 = [];
            this.getdate2 = [];
            this.formData = {};
            this.$emit("on-update", { search: this.formData, page: 1 });
        },
        // 两个时间的操作
        handleChange(date) {
            this.formData.GE_amazonTime = date[0];
            this.formData.LE_amazonTime = date[1];
        },
        createTime(data) {
            this.formData.GE_updatedAt = data[0];
            this.formData.LE_updatedAt = data[1];
        },
    },
};
</script>
